import { render, staticRenderFns } from "./WechatRedPacket.vue?vue&type=template&id=56c35fbc"
import script from "./WechatRedPacket.vue?vue&type=script&lang=js"
export * from "./WechatRedPacket.vue?vue&type=script&lang=js"
import style0 from "./WechatRedPacket.vue?vue&type=style&index=0&id=56c35fbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports